import { ReviewRatingAwardResponse, } from '../../sew-core/types/ApiResponses';
import { ReviewRatingAwardData, } from '../../sew-core/types/AppState';
import { getRraDataByVehicleId, getRraDataByVin, getRraDataByText, } from '../../sew-core/services/ReviewRatingAwardService';
import baseState from '../../sew-core/store/AppState';

async function requestRraData(urlParams: Record<string, string>): Promise<ReviewRatingAwardResponse | null> {
  try {
    const { apikey, year, make, model, vehicleid, vin, vehicleclass, panels, nocache, clientid, } = urlParams;

    let bypassCache = false;
    if (nocache) { // nocache may be undefined if it is not pass in as a parameter
      bypassCache = nocache.toLowerCase() === 'true';
    }

    let response: ReviewRatingAwardResponse | null = null;
    if (year && make && model) {
      response = await getRraDataByText(apikey, year, make, model, panels, clientid, bypassCache);
    } else if (vehicleid) {
      response = await getRraDataByVehicleId(apikey, vehicleid, panels, clientid, bypassCache);
    } else if (vin) {
      response = await getRraDataByVin(apikey, vin, vehicleclass, panels, clientid, bypassCache);
    }
    return response;
  } catch (e) {
    console.error(e);
    return e.response ? e.response.data : e;
  }
}

const getReviewRatingAwardData = async (urlParams: Record<string, string>): Promise<ReviewRatingAwardData | null> => {
  try {
    const rraResponse = await requestRraData(urlParams);
    if (rraResponse) {
      const expertReviewAndRating = (rraResponse.data && rraResponse.data.expertReview) || baseState.expertReviewAndRating;
      const consumerReview = rraResponse.data ? rraResponse.data.consumerReview : {
        numberOfReviews: baseState.consumerReviewAndRating.numberOfReviews,
        moreReviewsLink: baseState.consumerReviewAndRating.moreReviewsLink,
        consumerReviews: baseState.consumerReviewAndRating.consumerReviews,
      };
      const consumerRating = (rraResponse.data && rraResponse.data.consumerRating) ? rraResponse.data.consumerRating.ratings : baseState.consumerReviewAndRating.consumerRating;
      const vehicle = rraResponse.data ? rraResponse.data.vehicle : baseState.vehicle;
      const vehicleAward = (rraResponse.data && rraResponse.data.award) || baseState.vehicleAward;
      const { accountInfoData, } = rraResponse;
      const errors = rraResponse.errors || baseState.errors;
      const rraData: ReviewRatingAwardData = {
        expertReviewAndRating,
        consumerReviewAndRating: {
          ...consumerReview,
          consumerRating,
        },
        vehicle,
        vehicleAward,
        accountInfoData,
        errors,
      };
      return rraData;
    }
    return null;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export default getReviewRatingAwardData;
